import PropTypes from 'prop-types';
import { PLACEMENTS_SIDES } from '../PlacementConstants';
export const autoPlacementPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horiz', 'vert', 'dropdown'])]);
export const pinToConstraintPropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOf(PLACEMENTS_SIDES))]);